import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M27.172 2.307h.012c1.188.092 1.915.324 2.384.603.427.255.766.622 1.049 1.263.303.688.532 1.672.674 3.104.14 1.421.184 3.162.184 5.311s-.044 3.899-.184 5.332c-.142 1.444-.372 2.443-.677 3.142-.285.651-.623 1.014-1.036 1.256-.454.268-1.166.486-2.343.547h-.008c-4.94.275-15.999.275-20.957.001-1.176-.092-1.896-.322-2.363-.6-.427-.255-.766-.622-1.049-1.263-.303-.688-.532-1.672-.674-3.104C2.044 16.478 2 14.737 2 12.588s.044-3.89.184-5.31c.142-1.433.37-2.417.674-3.105.283-.64.622-1.008 1.049-1.263.47-.28 1.196-.51 2.383-.602l.013-.001c4.91-.41 15.958-.41 20.869 0M0 12.588c0 8.648.697 11.856 6.137 12.274 5.021.279 16.18.279 21.2 0 5.44-.279 6.138-3.626 6.138-12.274S32.778.732 27.338.314c-5.021-.419-16.18-.419-21.2 0C.697.732 0 3.94 0 12.588m14 4.856a1 1 0 0 1-1.447-.895V8.627A1 1 0 0 1 14 7.733l7.922 3.96a1 1 0 0 1 0 1.79z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }